import * as React from "react";
import type { SVGProps } from "react";
const SvgVariant = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeWidth={2}
      d="M20.186 12 12 20.186 3.814 12 12 3.814z"
    />
  </svg>
);
export default SvgVariant;
